// extracted by mini-css-extract-plugin
export default {"Skill":"Skill_Skill__Jw89v","name":"Skill_name__7Fmkr","description":"Skill_description__jmH++","swing-in":"Skill_swing-in__9U-Fq"};